import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../core/services/navigation/navigation.service';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  constructor(private navigation: NavigationService) { }

  ngOnInit() {
  }
  routeTo(route,both){
    this.navigation.navigateTo(route, '', both);
  }
}
